export const PERIOD_PERMISSIONS = ['monthly', 'weekly', 'daily'];
export const PERIOD_GRANULARITIES = [...PERIOD_PERMISSIONS, 'nielsen'];
//# sourceMappingURL=period.constant.js.map